import React, { useState, useEffect, useContext } from "react";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Form, InputGroup, Row } from "react-bootstrap";
import classNames from "classnames";
import Cookies from "js-cookie";
import { Context } from "../../../utils/context";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import {
  Country,
  State,
  City,
  Pincode,
} from "../../../utils/apis/master/Master";
import Select from "react-select";
import SuccessModal from "../../common/Successfull_Modal/Successfull_Modal";

function Stepfour({ user_id, showModal, setShowModal }) {
  // const [selectedRole, setSelectedRole] = useState("");
  // const handleRadioChange = (e) => {
  //   setSelectedRole(e.target.id);
  // };

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  // const { getData, IMG_URL, Select2Data, postData } = useContext(Context);
  // const {
  //   control,
  //   register,
  //   handleSubmit,
  //   getValues,
  //   setError,
  //   clearErrors,
  //   formState: { errors },
  //   reset,
  //   trigger,
  // } = useForm();

  // const onSubmit = async (data) => {
  //   if (data.password === data.c_password) {
  //     const formData = new FormData();
  //     formData.append("user_id", user_id);
  //     formData.append("first_name", data?.first_name);
  //     formData.append("email", data?.email);
  //     formData.append("contact_no", data?.contact_no);
  //     formData.append("password", data?.password);
  //     formData.append("role_in_store", selectedRole);
  //     formData.append("manager_name", data?.manager_name);
  //     formData.append("manager_email", data?.manager_email);
  //     formData.append("manager_contact_no", data?.manager_contact_no);
  //     formData.append("lat", data?.lat);
  //     formData.append("long", data?.long);
  //     formData.append("store_address", data?.store_address);
  //     formData.append("pincode_id", data?.pincode_id?.value);
  //     if (data?.manager_id) {
  //       formData.append("manager_id", data?.manager_id);
  //     }
  //     // if (newUserContact && newUserContact !== data?.contact_no) {
  //     //   formData.append("verified", false);
  //     // }

  //     try {
  //       const res = await postData(
  //         "/employee/seller-details/s-owner-details",
  //         formData
  //       );
  //       if (res?.success) {
  //         setShowModal({ code: res.code, message: res.message });
  //         // setNewUserContact(res?.data?.contact_no)
  //         // props.nextStep()
  //       } else {
  //         // Handle the case when res.success is false
  //         await setShowModal({ code: res.code, message: res.message });
  //         console.error("Failed to submit data");
  //       }
  //     } catch (error) {
  //       // Handle any errors that occur during the request
  //       console.error("An error occurred while submitting data:", error);
  //     }
  //   } else {
  //     setError("password", {
  //       message: "Password Must Match",
  //     });
  //   }
  // };
  // const [pincode, setPincode] = useState([]);
  // const getEditData = async () => {
  //   const res = await getData(`/employee/seller-details/s-owner-details`);
  //   if (res?.success) {
  //     reset(res?.data);
  //     getPincode(res?.data);
  //     if (res?.data?.manager_id) {
  //       setSelectedRole("Manager");
  //     } else {
  //       setSelectedRole("Owener");
  //     }
  //   }
  // };

  // const getPincode = async (data) => {
  //   const res = await Pincode(data?.city_id);
  //   if (res?.success) {
  //     const data = await Select2Data(res?.data, "pincode_id", false);
  //     setPincode(data);
  //   }
  // };
  // useEffect(() => {
  //   getEditData();
  // }, [user_id]);

  const { IMG_URL, Select2Data, postData, getData } = useContext(Context);

  const [cityOptions, setCityOptions] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [loadingPincodes, setLoadingPincodes] = useState(false);
  // const [user_id, setUserId] = useState(Cookies.get("seller_user_id") || "");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const imageFile1 = watch("logo");
  const imageFile2 = watch("license_image");

  // Load Cities on mount
  const loadCities = async () => {
    const res = await getData(`/allcity`);
    if (res?.success) {
      const data = await Select2Data(res.data, "city_id", false);
      setCityOptions(data);
    }
  };

  // Load Pincodes when city changes
  const handleCityChange = async (selectedCity) => {
    setValue("city_id", selectedCity);
    setValue("pincode_id", null); // reset pincode
    setPincodeOptions([]);

    if (selectedCity?.value) {
      setLoadingPincodes(true);
      const res = await getData(`/allpincodes/${selectedCity?.value}`);
      if (res?.success) {
        const data = await Select2Data(res.data, "pincode_id", false);
        setPincodeOptions(data);
      }
      setLoadingPincodes(false);
    }
  };

  // Fetch existing draft data if user_id exists
  const fetchDraftData = async () => {
    if (!user_id) return;

    try {
      const res = await getData(`/employee/seller-details/${user_id}`);
      if (res?.success) {
        const seller = res.data;
        const details = seller.seller_detail || {};

        reset({
          first_name: seller.first_name || "",
          contact_no: seller.contact_no || "",
          email: seller.email || "",
          whatsapp_number: details.whatsapp_number || "",
          city_id: null, // will be set below
          pincode_id: null,
          area: details.area || "",
          shop_name: details.shop_name || "",
          certification_name: details.certification_name || "",
          // license: details.license || "",
          // license_expiry_date: details.license_expiry_date
          //   ? new Date(details.license_expiry_date)
          //   : null,
          registration_number: details.registration_number || "",
          // license_type: details.license_type || "",
          // license_name: details.license_name || "",
          // license_address: details.license_address || "",
          logo: details.logo || "",
          license_image: details.license_image || "",
        });

        // Preselect city & load its pincodes
        if (details.city_id) {
          const cityObj = cityOptions.find((c) => c.value == details.city_id);
          if (cityObj) {
            setValue("city_id", cityObj);
            // Load pincodes for this city
            setLoadingPincodes(true);
            const pinRes = await getData(`/allpincodes/${details.city_id}`);
            if (pinRes?.success) {
              const pinData = await Select2Data(
                pinRes.data,
                "pincode_id",
                false,
              );
              setPincodeOptions(pinData);

              const pinObj = pinData.find((p) => p.value == details.pincode_id);
              if (pinObj) setValue("pincode_id", pinObj);
            }
            setLoadingPincodes(false);
          }
        }
      }
    } catch (err) {
      console.log("Error loading draft:", err);
    }
  };

  useEffect(() => {
    loadCities();
  }, []);

  useEffect(() => {
    if (user_id && cityOptions.length > 0) {
      fetchDraftData();
    }
  }, [user_id, cityOptions]);

  const onSubmit = async (data) => {
    const formData = new FormData();

    // Append all fields
    formData.append("first_name", data.first_name);
    formData.append("contact_no", data.contact_no);
    formData.append("email", data.email);
    formData.append("city_id", data.city_id?.value || "");
    formData.append("pincode_id", data.pincode_id?.value || "");
    formData.append("area", data.area);
    formData.append("shop_name", data.shop_name);
    formData.append("whatsapp_number", data.whatsapp_number || "");
    formData.append("certification_name", data.certification_name);
    // formData.append("license", data.license);
    // formData.append(
    //   "license_expiry_date",
    //   data.license_expiry_date
    //     ? data.license_expiry_date.toISOString().split("T")[0]
    //     : ""
    // );
    formData.append("registration_number", data.registration_number);
    // formData.append("license_type", data.license_type);
    // formData.append("license_name", data.license_name);
    // formData.append("license_address", data.license_address);

    if (data.logo && data.logo[0]) {
      formData.append("logo", data.logo[0]);
    }
    if (data.license_image && data.license_image[0]) {
      formData.append("license_image", data.license_image[0]);
    }

    if (user_id) {
      formData.append("user_id", user_id);
    }

    try {
      const res = await postData("/employee/seller-details/add", formData);

      if (res?.success) {
        setShowModal({ code: res.code, message: res.message });
        // setNewUserContact(res?.data?.contact_no)
        // props.nextStep()
      } else {
        // Handle the case when res.success is false
        await setShowModal({ code: res.code, message: res.message });
       
      }
       setTimeout(() => {
        setShowModal(0);
      }, 1000);
    } catch (error) {
      console.error(error);
      // alert("Error saving data");
    }
  };

  return (
    <section className="personal-details-form userForm">
      <div className="details-form-holder">
        <div className="form-container">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              <div className="row">
                {/* Owner Name */}
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required">Name of Owner*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name of Owner"
                      {...register("first_name", {
                        required: "First name is required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.first_name,
                      })}
                    />
                    {errors.first_name && (
                      <span className="text-danger">
                        {errors.first_name.message}
                      </span>
                    )}
                  </div>
                </div>

                {/* Contact Number */}
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Owner Contact Number*
                    </Form.Label>
                    <div className="get-otp-text">
                      <Form.Control
                        type="text"
                        placeholder="Enter Owner Contact Number"
                        {...register("contact_no", {
                          required: "Contact number is required",
                          validate: {
                            isTenDigits: (v) =>
                              (v && v.length === 10) || "Must be 10 digits",
                            isNumeric: (v) =>
                              /^\d+$/.test(v) || "Only numbers allowed",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.contact_no,
                          "is-valid":
                            !errors?.contact_no &&
                            getValues("contact_no")?.length === 10,
                        })}
                        onKeyDown={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            !["Backspace", "Tab"].includes(e.key)
                          )
                            e.preventDefault();
                          if (
                            e.target.value.length >= 10 &&
                            !["Backspace", "Tab"].includes(e.key)
                          )
                            e.preventDefault();
                        }}
                      />
                      {errors.contact_no && (
                        <span className="text-danger">
                          {errors.contact_no.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Owner Email ID*
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Owner Email ID"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Invalid email address",
                        },
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.email,
                      })}
                    />
                    {errors.email && (
                      <span className="text-danger">
                        {errors.email.message}
                      </span>
                    )}
                  </div>
                </div>

                {/* WhatsApp Number */}
                <div className="col-md-6 mb-3">
                  <Form className="field-bottom">
                    <Form.Label className="required">
                      WhatsApp Number
                    </Form.Label>
                    <div className="get-otp-text">
                      <Form.Control
                        type="text"
                        placeholder="Enter WhatsApp Number"
                        {...register("whatsapp_number", {
                          validate: (v) =>
                            !v ||
                            (v.length === 10 && /^\d+$/.test(v)) ||
                            "Must be 10 digits",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.whatsapp_number,
                          "is-valid":
                            !errors?.whatsapp_number &&
                            getValues("whatsapp_number")?.length === 10,
                        })}
                        onKeyDown={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            !["Backspace", "Tab"].includes(e.key)
                          )
                            e.preventDefault();
                          if (
                            e.target.value.length >= 10 &&
                            !["Backspace", "Tab"].includes(e.key)
                          )
                            e.preventDefault();
                        }}
                      />
                      {errors.whatsapp_number && (
                        <span className="text-danger">
                          {errors.whatsapp_number.message}
                        </span>
                      )}
                    </div>
                  </Form>
                </div>

                {/* City */}
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required">City</Form.Label>
                    <Controller
                      name="city_id"
                      control={control}
                      rules={{ required: "Please select a city" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={cityOptions}
                          placeholder="Select City"
                          onChange={handleCityChange}
                          isSearchable
                          isClearable
                        />
                      )}
                    />
                    {errors.city_id && (
                      <span className="text-danger">
                        {errors.city_id.message}
                      </span>
                    )}
                  </div>
                </div>

                {/* Pincode - Right next to City */}
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required">Pincode</Form.Label>
                    <Controller
                      name="pincode_id"
                      control={control}
                      rules={{ required: "Please select a pincode" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={pincodeOptions}
                          placeholder={
                            loadingPincodes ? "Loading..." : "Select Pincode"
                          }
                          isDisabled={loadingPincodes}
                          isSearchable
                          isClearable
                        />
                      )}
                    />
                    {errors.pincode_id && (
                      <span className="text-danger">
                        {errors.pincode_id.message}
                      </span>
                    )}
                  </div>
                </div>

                {/* Area */}
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required">Area</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Area"
                      {...register("area", { required: "Area is required" })}
                    />
                    {errors.area && (
                      <span className="text-danger">{errors.area.message}</span>
                    )}
                  </div>
                </div>

                {/* Shop Name */}
                <div className="col-md-6 mb-3">
                  <div className="form-field">
                    <Form.Label className="required">
                      Shop / Showroom Name*
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Shop/Showroom Name"
                      {...register("shop_name", {
                        required: "Shop name required",
                      })}
                    />
                    {errors.shop_name && (
                      <span className="text-danger">
                        {errors.shop_name.message}
                      </span>
                    )}
                  </div>
                </div>

                {/* Logo Upload */}
                <div className="col-lg-6 col-md-9 mb-3">
                  <div className="img_input_holder">
                    <div className="img_form_field mb-4">
                      <Form.Label className="required">Logo*</Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        {...register("logo")}
                      />
                    </div>

                    <div className="img_container mt-3">
                      <Row className="">
                        <div className="col-md-12">

                        <Form.Label>Image Preview</Form.Label>
                        {typeof getValues("logo") === "string" &&
                        getValues("logo") ? (
                          <div>

                            <img
                              src={IMG_URL + getValues("logo")}
                              alt="Preview"
                              style={{
                                width: "80px",
                                height: "80px",
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          </div>
                        ) : (
                          imageFile1?.length > 0 && (
                            <div>

                              <img
                                src={URL.createObjectURL(imageFile1[0])}
                                alt="Preview"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  marginTop: "10px",
                                  aspectRatio: "1 / 1",
                                  objectFit: "contain",
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                }}
                              />
                            </div>
                          )
                        )}
                        </div>
                      </Row>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-9 mb-3">
                  <div className="img_input_holder">
                    <div className="img_form_field mb-4">
                      <Form.Label className="required">
                        License Image*
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        {...register("license_image")}
                      />
                    </div>

                        <Form.Label>Image Preview</Form.Label>
                        <div>

                        {typeof getValues("license_image") === "string" &&
                        getValues("license_image") ? (
                          <img
                            src={IMG_URL + getValues("license_image")}
                            alt="Preview"
                            style={{
                              width: "80px",
                              height: "80px",
                              aspectRatio: "1 / 1",
                              objectFit: "contain",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                            }}
                          />
                        ) : (
                          imageFile2?.length > 0 && (
                            <img
                              src={URL.createObjectURL(imageFile2[0])}
                              alt="Preview"
                              style={{
                                width: "80px",
                                height: "80px",
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          )
                        )}
                        </div>


                    
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Group controlId="name">
                      <Form.Label className="required">
                        Name of Certification
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="certification_name"
                        placeholder="Enter Name of Certification"
                        className={classNames("", {
                          "is-invalid": errors?.certification_name,
                        })}
                        {...register("certification_name", {
                          required: "Certification Name is required",
                        })}
                      />
                      {errors.certification_name && (
                        <span className="text-danger">
                          {errors.certification_name.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                </div>

                {/* <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">License</Form.Label>

                        <Form.Control
                          type="text"
                          name="license"
                          placeholder="Enter License"
                          className={classNames("", {
                            "is-invalid": errors?.license,
                          })}
                          {...register("license", {
                            required: "license is required",
                          })}
                        />

                        {errors.license && (
                          <span className="text-danger">
                            {errors.license.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div> */}

                {/* <div className="col-md-6">
                    <div className="form-field">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">
                          License Expiry Date
                        </Form.Label>

                        <Controller
                          control={control}
                          name="license_expiry_date"
                          rules={{
                            required: "License expiry date is required",
                          }}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              selected={field.value}
                              onChange={(date) => field.onChange(date)}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="Select License Expiry Date"
                              minDate={new Date()}
                              className={classNames("form-control", {
                                "is-invalid": errors?.license_expiry_date,
                              })}
                            />
                          )}
                        />

                        {errors.license_expiry_date && (
                          <span className="text-danger">
                            {errors.license_expiry_date.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div> */}

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Group controlId="Last_Name">
                      <div className="d-flex justify-content-between">
                        <Form.Label className="required form-field">
                          Enter License Number
                        </Form.Label>
                        {/* <p className="mb-0 validate" onClick={handleFields}>Validate</p> */}
                      </div>

                      <div className="get-otp-text">
                        <Form.Control
                          type="text"
                          name="registration_number"
                          placeholder="Enter License Number"
                          className={classNames("", {
                            "is-invalid": errors?.registration_number,
                          })}
                          {...register("registration_number", {
                            required: "Enter License Number",
                          })}
                        />

                        {errors.registration_number && (
                          <span className="text-danger">
                            {errors.registration_number.message}
                          </span>
                        )}
                      </div>
                    </Form.Group>
                  </div>
                </div>

                {/* {fieldclick && ( */}
                <>
                  {/* <div className="col-md-6">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            License Type
                          </Form.Label>

                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="license_type"
                              placeholder="License Type"
                              className={classNames("", {
                                "is-invalid": errors?.license_type,
                              })}
                              {...register("license_type", {
                                required: "License Type is required",
                              })}
                            />

                            {errors.license_type && (
                              <span className="text-danger">
                                {errors.license_type.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div> */}

                  {/* <div className="col-md-6">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            Name on License*
                          </Form.Label>
                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="license_name"
                              placeholder="Enter Name on License"
                              className={classNames("", {
                                "is-invalid": errors?.license_name,
                              })}
                              {...register("license_name", {
                                required: "license_name is required",
                              })}
                            />

                            {errors.license_name && (
                              <span className="text-danger">
                                {errors.license_name.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div> */}

                  {/* <div className="col-md-12">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            Address in License
                          </Form.Label>
                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="license_address"
                              placeholder="License Type"
                              className={classNames("", {
                                "is-invalid": errors?.license_address,
                              })}
                              {...register("license_address", {
                                required: "License Address is required",
                              })}
                            />

                            {errors.license_address && (
                              <span className="text-danger">
                                {errors.license_address.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div> */}
                </>

                <div className="col-md-12 mt-3">
                  <div className="text-end apply_now_btn">
                    <div className="registerContinueMain">
                      <Button className="walletBtn" type="submit">
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
          {/* <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-6">
                <div className="field-bottom">
                  <Form.Label className="required">Name of Owner*</Form.Label>
                  <Form.Control
                    type="text"
                    name="first_name"
                    placeholder="Name of Owner"
                    className={classNames("", {
                      "is-invalid": errors?.first_name,
                    })}
                    {...register("first_name", {
                      required: "first_name is required",
                    })}
                  />

                  {errors.first_name && (
                    <span className="text-danger">
                      {errors.first_name.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="field-bottom">
                  <Form.Label className="required">Owner Email ID*</Form.Label>

                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Owner Email ID"
                    className={classNames("", {
                      "is-invalid": errors?.email,
                    })}
                    {...register("email", {
                      required: "email is required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Invalid email address",
                      },
                    })}
                  />

                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="field-bottom">
                  <Form.Label className="required">
                    Owner Contact Number*
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="contact_no"
                    placeholder="Owner Contact Number"
                    {...register("contact_no", {
                      required: "contact_no is required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.contact_no,
                      "is-valid":
                        !errors?.contact_no &&
                        getValues("contact_no")?.length === 10,
                    })}
                    onKeyDown={(event) => {
                      const { key } = event;
                      if (
                        !/[0-9]/.test(key) &&
                        key !== "Backspace" &&
                        key !== "Tab"
                      ) {
                        event.preventDefault();
                      }
                      if (
                        event.target.value?.length >= 10 &&
                        key !== "Backspace" &&
                        key !== "Tab"
                      ) {
                        event.preventDefault();
                      }
                    }}
                  />

                  {errors.contact_no && (
                    <span className="text-danger">
                      {errors.contact_no.message}
                    </span>
                  )}
                </div>
              </div>

            </div>

          
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="field-bottom">
                  <Form.Label className="required form-field">Role*</Form.Label>
                  <div className="row get-otp-text">
                    <div className="col-lg-6">
                      <Form.Check
                        type="radio"
                        label="Owner"
                        id="Owner"
                        checked={selectedRole === "Owner"}
                        name="role"
                        onChange={handleRadioChange}
                      />
                    </div>
                    <div className="col-lg-6">
                      <Form.Check
                        type="radio"
                        label="Manager"
                        id="Manager"
                        name="role"
                        checked={selectedRole === "Manager"}
                        onChange={handleRadioChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {selectedRole === "Owner" && <div className="row"></div>}

            {selectedRole === "Manager" && (
              <div className="row">
                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Manager Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="manager_name"
                      placeholder="manager_name"
                      className={classNames("", {
                        "is-invalid": errors?.manager_name,
                      })}
                      {...register("manager_name", {
                        required: "manager_name is required",
                      })}
                    />

                    {errors.manager_name && (
                      <span className="text-danger">
                        {errors.manager_name.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Manager Email ID
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="manager_email"
                      placeholder="manager_email"
                      className={classNames("", {
                        "is-invalid": errors?.manager_email,
                      })}
                      {...register("manager_email", {
                        required: "manager_email is required",
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "Invalid manager_email address",
                        },
                      })}
                    />

                    {errors.manager_email && (
                      <span className="text-danger">
                        {errors.manager_email.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Manager Contact Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="manager_contact_no"
                      placeholder="manager_contact_no"
                      {...register("manager_contact_no", {
                        required: "manager_contact_no is required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.manager_contact_no,
                        "is-valid":
                          !errors?.manager_contact_no &&
                          getValues("manager_contact_no")?.length === 10,
                      })}
                      onKeyDown={(event) => {
                        const { key } = event;
                        if (
                          !/[0-9]/.test(key) &&
                          key !== "Backspace" &&
                          key !== "Tab"
                        ) {
                          event.preventDefault();
                        }
                        if (
                          event.target.value?.length >= 10 &&
                          key !== "Backspace" &&
                          key !== "Tab"
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />

                    {errors.manager_contact_no && (
                      <span className="text-danger">
                        {errors.manager_contact_no.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div style={{ width: "100%" }} className="mb-4">
              <iframe
                width="100%"
                height="600"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=profcyma%20global%20solution+(Wesbite)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              >
                <a href="https://www.gps.ie/">gps trackers</a>
              </iframe>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="field-bottom">
                  <Form.Label className="required form-field">
                    Longitude
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="long"
                    placeholder="long"
                    className={classNames("", {
                      "is-invalid": errors?.long,
                    })}
                    {...register("long", {
                      required: "long is required",
                    })}
                  />

                  {errors.long && (
                    <span className="text-danger">{errors.long.message}</span>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="field-bottom">
                  <Form.Label className="required form-field">
                    Latitude
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="lat"
                    placeholder="lat"
                    className={classNames("", {
                      "is-invalid": errors?.lat,
                    })}
                    {...register("lat", {
                      required: "lat is required",
                    })}
                  />

                  {errors.lat && (
                    <span className="text-danger">{errors.lat.message}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="field-bottom">
                <Form.Label className="required form-field">
                  store_address
                </Form.Label>
                <Form.Control
                  type="text"
                  name="store_address"
                  placeholder="store_address"
                  className={classNames("", {
                    "is-invalid": errors?.store_address,
                  })}
                  {...register("store_address", {
                    required: "store_address is required",
                  })}
                />

                {errors.store_address && (
                  <span className="text-danger">
                    {errors.store_address.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="field-bottom">
                <Form.Label className="required form-field">
                  Postal Code
                </Form.Label>
                <Controller
                  name="pincode_id" // name of the field
                  {...register("pincode_id", {
                    required: "Select Pincode",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.pincode_id ? "red" : baseStyles,
                        }),
                      }}
                      {...field}
                      options={pincode}
                    />
                  )}
                />

                {errors.pincode_id && (
                  <span className="text-danger">
                    {errors.pincode_id.message}
                  </span>
                )}
              </div>
            </div>
<hr/>
            <div className="col-md-12">
              <div className="text-center apply_now_btn">
                <div className="registerContinueMain">
                 
                  <Button
                    className="walletBtn"
                    type="submit"
                   
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </Form> */}
        </div>
      </div>
    </section>
  );
}

export default Stepfour;
